import React, { useState, useReducer } from "react";
import PropTypes from "prop-types";
import Current from "./Current";
import Upcoming from "./Upcoming";
import Placeholder from "./Placeholder";
import Past from "./Past";
import NavBar from "./NavBar";
import values from "lodash/values";

const initialSectionVisibility = {
  current: true,
  upcoming: true,
  past: true,
};

function sectionReducer(state, action) {
  return { ...state, [action.type]: action.value };
}

const DEFAULT_PAST_QUERY = { page: 1 };

function ExhibitionsLanding({ openCloseMessage }) {
  const [query, setQuery] = useState({});
  const [pastQuery, setPastQuery] = useState(DEFAULT_PAST_QUERY);
  const [visibleSections, dispatchVisibleSections] = useReducer(
    sectionReducer,
    initialSectionVisibility
  );
  const hasVisibleSections = values(visibleSections).includes(true);

  const handleFilterChange = (query) => {
    // handle clear event
    if (!query) {
      setQuery({});
      setPastQuery(DEFAULT_PAST_QUERY);
      return;
    }

    setQuery((prevQuery) => ({ ...prevQuery, ...query }));
    // Reset pagination on past query
    setPastQuery((prevQuery) => ({ ...prevQuery, page: 1, ...query }));
  };

  // Get next page
  const handlePageChange = () =>
    setPastQuery((query) => ({
      ...query,
      page: pastQuery.page + 1,
    }));

  const handleFetch = (type, hasExhibitions) =>
    dispatchVisibleSections({ type, value: hasExhibitions });

  return (
    <>
      <NavBar
        onFilterChange={handleFilterChange}
        visibleSections={visibleSections}
      />
      <Current
        id="current"
        heading="Current Exhibitions"
        openCloseMessage={openCloseMessage}
        query={query}
        onFetch={handleFetch}
      />
      <Upcoming
        id="upcoming"
        heading="Upcoming Exhibitions"
        query={query}
        onFetch={handleFetch}
      />
      <Past
        id="past"
        heading="Past Exhibitions"
        query={pastQuery}
        onFetch={handleFetch}
        onNextPage={handlePageChange}
      />
      {!hasVisibleSections && <Placeholder />}
    </>
  );
}

ExhibitionsLanding.propTypes = {
  openCloseMessage: PropTypes.string,
};

export default ExhibitionsLanding;
